import { FC } from 'react';
import {
  TextLink,
  TextLinkStyle,
  CardRadioButton,
  MLPVersion,
  Theme,
  Tag,
  useTranslation,
  TagStyle,
} from '@nextgen-web-framework/all';
import { ICheckoutPickupStoresOptions } from '@commerce-checkout-webcomponents/sdk';
import { ICheckoutStoreOptionRadioCardProps } from '../types/propTypes';
import { checkoutShippingDetailsActions } from '../../common/config/checkoutConstants';
import styles from './CheckoutStoreOptionRadioCard.module.scss';

export const CheckoutStoreOptionRadioCard: FC<ICheckoutStoreOptionRadioCardProps> = ({
  cardData,
  dispatchAction,
  isSelected,
  showAvailabilityTag,
  showDistance,
  showLine1AsName,
}: ICheckoutStoreOptionRadioCardProps) => {
  const t = useTranslation();
  const distance = cardData.serviceLocation?.distanceInMiles
    ? (cardData.serviceLocation?.distanceInMiles * 1.609344).toFixed(2)
    : '';

  const showStoreDetails = (cardData: ICheckoutPickupStoresOptions) => {
    dispatchAction({
      type: checkoutShippingDetailsActions.SET_STORE_DETAILS_DATA,
      payload: cardData,
    });
    dispatchAction({
      type: checkoutShippingDetailsActions.SET_STORE_DETAILS_DRAWER_VISIBILITY,
      payload: true,
    });
  };

  const onSelectCard = (cardData: ICheckoutPickupStoresOptions) => {
    if (cardData?.id && cardData?.serviceLocation) {
      dispatchAction({
        type: checkoutShippingDetailsActions.SET_SELECTED_STORE_ID,
        payload: cardData.id,
      });
      dispatchAction({
        type: checkoutShippingDetailsActions.SET_SELECTED_SERVICE_LOCATION,
        payload: cardData.serviceLocation,
      });
    }
  };

  const showItemAvailableTag = (cardData: ICheckoutPickupStoresOptions) =>
    showAvailabilityTag && cardData.allItemsAvailable != undefined && !cardData.allItemsAvailable;

  return (
    <div className={styles['checkout-store-option-card-wrapper']}>
      <CardRadioButton
        mlpVersion={MLPVersion.ONE}
        label={
          <div className={styles['checkout-store-option-card-label-conatainer']}>
            <span className={`${isSelected && styles['checkout-store-option-card-store-name']}`}>
              {showLine1AsName ? cardData?.line1 : cardData?.name}
            </span>
            {/* {cardData?.id && <span className={styles['checkout-store-option-card-label-separator']}></span>}
            <span className={`${isSelected && styles['checkout-store-option-card-storeId']}`}>{cardData?.id}</span> */}
          </div>
        }
        checked={isSelected}
        onChange={() => onSelectCard(cardData)}
        className={styles['store-option-radio-card']}
        theme={isSelected ? Theme.PURPLE : Theme.BLACK}
      >
        <div className={styles['store-card-children-container']}>
          {showItemAvailableTag(cardData) && (
            <div className={styles['availabilityTag']}>
              <Tag
                theme={Theme.WARNING}
                style={TagStyle.OUTLINE}
                text={t('checkout.CheckoutStoreOptionRadioCard.itemUnavailable')}
              />
            </div>
          )}
          <p>
            <span className={styles['store-address-line']}>{cardData?.addressLine}</span>
          </p>
          <p className={styles['store-card-footer']}>
            <span>
              <TextLink
                id={styles['store-details']}
                data-testid="store-details"
                text={t('checkout.CheckoutStoreOptionRadioCard.storeDetails')}
                textLinkStyle={TextLinkStyle.UNDERLINE}
                theme={Theme.PURPLE}
                onClick={() => showStoreDetails(cardData)}
                scroll={false}
              />
            </span>
            {showDistance && distance && (
              <span className={styles['store-distance']}>
                {t('checkout.CheckoutStoreOptionRadioCard.distance', { distance })}
              </span>
            )}
          </p>
        </div>
      </CardRadioButton>
    </div>
  );
};

export default CheckoutStoreOptionRadioCard;
